<template>
  <div>
    <div v-if="!!getActiveWarehouse">
      <PageTitle title="Custom Fields" />
      <div class="alerts-wrapper" v-if="letShowUpdatePlanMessage">
        <div class="alerts-wrapper__icon">
          <v-img width="24px" height="24px" src="@/assets/icons/svg/alert.svg" />
        </div>
        <div class="alerts-wrapper__text">
          You can add 20 custom fields on the {{currentUserPlan}} plan.
          {{getUsed('customFields')}} of {{getLimit('customFields')}} custom fields added.
          <b>
            <span class="update-plan-link text-yellow-9" @click="showUpgradeSubscriptionPlanPopup">Update Plan</span>
          </b>
        </div>
      </div>
      <div class="table-wrapper mt-6">
        <v-row class="table-controls mb-1 items-center">
          <v-col sm="6" md="6" lg="6">
            <div v-if='$getRight("customFieldView") && $getRight("customFieldCreate")'>
              <v-btn
                v-if='getUsed("customFields")<getLimit("customFields")'
                color='transparent'
                depressed
                @click='$emit("changeType", "customFieldsAdding", null)'
                class='px-2'
              >
                <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
                <span class="text-subtitle-2 font-weight-bold">Add Custom Field</span>
              </v-btn>
              <v-btn
                v-else
                color='transparent'
                depressed
                @click='showUpgradeSubscriptionPlanPopup'
              >
                <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
                <span class="text-subtitle-2 font-weight-bold">Add Custom Field</span>
              </v-btn>
            </div>
          </v-col>
          <v-col sm="6" md="6" lg="6">
            <div class="d-flex justify-end">
              <v-btn
                v-if='selectedItems.length && $getRight("customFieldDelete")'
                color='transparent'
                depressed
                @click='customFieldsDeleteDialog=true'
              >
                <v-img max-height="20" max-width="20" class="mr-2" src="@/assets/icons/svg/delete1.svg" />
                <span class="text-subtitle-2 font-weight-bold">Delete</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-divider />
        <v-row class="justify-space-between">
          <v-col cols="12" class="px-0">
            <v-data-table
              :headers="headers"
              :items="items"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              :custom-filter="filterOneColumnTable"
              item-key="created"
              @page-count="pageCount = $event"
              class="cursor-point"
              hide-default-footer
            >
              <template v-slot:no-results>
                <p class="text-h5 mt-16">There is no custom fields created</p>
              </template>
              <template v-slot:[`item.selected`]="{ item }">
                <v-simple-checkbox
                  v-if='$getRight("customFieldDelete")'
                  v-model="item.selected"
                  color="#7972c0"
                  :ripple="false"
                ></v-simple-checkbox>
              </template>
              <template v-slot:[`item.visibility`]="{ item }">
                <v-icon
                  :disabled='!$getRight("customFieldEdit")'
                  medium
                  light
                  @click='changeActivityItem(item)'
                  :class="{
                    'visibility-item-hidden':!item.active,
                    'visibility-item-forAll':item.applyTo === 'All items'
                  }"
                >
                  {{ item.applyTo === "All items" ? "mdi-eye-check" : item.active ? "mdi-eye" : "mdi-eye-off" }}
                </v-icon>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-row class="flex-nowrap">
                  <v-col cols="4" class="px-0" v-if='$getRight("customFieldEdit")'>
                    <img
                      class="mr-1 cursor-pointer"
                      style="height: 16px; width: 16px"
                      src="@/assets/icons/svg/draw.svg"
                      @click.passive='$emit("changeType", "customFieldsEdit", item.id)'
                      title="Edit"
                    />
                  </v-col>
                  <v-col cols="4" class="px-0" v-if='$getRight("customFieldDelete")'>
                    <img
                      style="height: 16px; width: 16px"
                      src="@/assets/icons/svg/delete1.svg"
                      class="cursor-pointer"
                      @click.passive="manualDeleteItem(item)"
                      title="Delete"
                    />
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row class="pagination-wrapper">
          <v-col cols="5">
            <span class="text-nowrap mr-2">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  style="padding: 0; font-weight: 600"
                >
                  {{ itemsPerPage }}
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in itemsPerPageOptions"
                  :key="index"
                  link
                  @click="itemsPerPage = item"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="7" class="d-flex justify-end">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="5"
              color="#7972C0"
            />
          </v-col>
        </v-row>
      </div>
    </div>
    <SelectWarehouse v-else />
    <!-- delete custom fields modal -->
    <v-dialog v-model="customFieldsDeleteDialog" persistent max-width="520">
      <v-card class="pa-4">
        <v-card-title class="headline justify-center popup-title" v-if='manualDeletingItem'>
          Are you sure want to delete custom field "{{ selectedItems.length?selectedItems[0].name:'' }}"?
        </v-card-title>
        <v-card-title class="headline justify-center popup-title" v-else>
          Are you sure want to delete selected custom fields?
        </v-card-title>
        <v-card-text
          v-if="manualDeletingItem && selectedItems[0].used"
          class="d-flex justify-center red--text"
        >
          <p class="text-center">Тhis custom field is used by items.<br>Deleting it will remove from items too</p>
        </v-card-text>
        <v-card-text
          v-else-if="!manualDeletingItem && selectedItems.some(item => item.used)"
          class="d-flex justify-center red--text"
        >
          <p class="text-center">Тhis custom field is used by items.<br>Deleting it will remove from items too</p>
        </v-card-text>
        <v-card-actions class="text-xs-center justify-center">
          <v-btn
            @click="closeDeletingDialog"
            depressed
            class="cancel-btn small-size"
          >
            Cancel
          </v-btn>
          <v-btn
            @click='deleteItem'
            depressed
            class="save-btn small-size"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { firstCharUppercase } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import services from '@/services/customField'
import { getLimitMixin } from '@/mixins/getLimit'
import { SET_USED_CUSTOM_FIELDS } from '@/store/constant/mutation-types'
import PageTitle from '@/components/page/PageTitle'
import SelectWarehouse from '@/views/SelectWarehouse'

export default {
  name: 'customFieldsTable',
  components: {
    PageTitle,
    SelectWarehouse
  },
  data: function() {
    return {
      navSettingsOptions: [
        {
          index: 1,
          text: 'Settings'
        },
        {
          index: 2,
          text: 'Custom Fields'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      itemsPerPageOptions: [5, 10, 20, 25, 50],
      items: [],
      headers: [
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'selected'
        },
        {
          text: 'Name',
          value: 'name',
          sortable: true,
          align: 'start',
          width: 150
        },
        {
          text: 'Visible in List view',
          value: 'visibility',
          sortable: false,
          align: 'center',
          width: 150
        },
        { text: 'Type', value: 'fieldType', sortable: true, align: 'start' },
        { text: 'Applicable to', value: 'applyTo', sortable: true, align: 'start' },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ],
      manualDeletingItem: false,
      customFieldsDeleteDialog: false,
      currentUserPlan: '',
      UpgradePlanPopupIsOpen: false,
      accessRights: ['customFieldView', 'customFieldCreate', 'customFieldEdit', 'customFieldDelete']
    }
  },
  mixins: [getLimitMixin],
  computed: {
    ...mapGetters('warehouses', ['getActiveWarehouse']),
    selectedItems() {
      return this.items?.filter(item => item.selected)
    },
    letShowUpdatePlanMessage() {
      const plan = this.currentUserPlan
      if (plan === 'Free' || plan === 'No Plan' || plan === 'Business') return true
      return false
    }
  },
  watch: {
    getActiveWarehouse(v) {
      if (v) this.buildTable()
    }
  },
  methods: {
    ...mapActions(['showUpgradeSubscriptionPlanPopup']),
    filterOneColumnTable(value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        (item.name.toLowerCase().includes(search.toLowerCase()) ||
          item.description.toLowerCase().includes(search.toLowerCase()))
      )
    },
    manualDeleteItem(item, i) {
      this.items.forEach(el => {
        el.selected = false
      })
      item.selected = true
      this.customFieldsDeleteDialog = true
      this.manualDeletingItem = true
    },
    closeDeletingDialog() {
      if (this.manualDeletingItem) {
        this.items.forEach(item => { if (item.selected) item.selected = false })
      }
      this.manualDeletingItem = false
      this.customFieldsDeleteDialog = false
    },
    async deleteItem() {
      const response = await services.deleteCustomField({ ids: this.selectedItems.map(item => item.id) })

      if (response?.data?.error?.type === 200) {
        this.selectedItems.forEach(item => {
          this.items.splice(this.items.findIndex(el => el.id === item.id), 1)
          this.manualDeletingItem = false
          this.customFieldsDeleteDialog = false
          this.$store.commit(`user/${SET_USED_CUSTOM_FIELDS}`, this.items.length)
        })
      }
    },
    async changeActivityItem(item) {
      if (item.applyTo !== 'All items') {
        await services.changeCustomField({ id: item.id, active: !item.active })
        item.active = !item.active
      }
    },
    ...mapActions([
      'showUpgradeSubscriptionPlanPopup'
    ]),
    async buildTable() {
      const inventoryId = this.getActiveWarehouse.id
      const result = await services.getCustomFieldsList({ inventoryId: inventoryId })
      const templates = result.data.data
      const resultArray = []
      for (let i = 0; i < templates.length; i++) {
        const currentItem = {
          active: templates[i].active,
          id: templates[i].id,
          selected: false,
          name: templates[i].name,
          fieldType: templates[i].fieldType,
          applyTo: firstCharUppercase(templates[i].applyTo.split('_').join(' ')),
          used: templates[i].used
        }
        resultArray.push(currentItem)
      }
      this.items = resultArray
      this.$store.commit(`user/${SET_USED_CUSTOM_FIELDS}`, this.items.length)
    }
  },
  created() {
    this.currentUserPlan = JSON.parse(localStorage.getItem('curUserData')).plan.name
    if (this.getActiveWarehouse) {
      this.buildTable()
    }
  }
}
</script>

<style lang='scss'>
  .v-data-table-header{
    background-color: #f5f5f5;
  }
  .v-data-footer{
    background-color: #f5f5f5;
  }
  .theme--light .v-data-table__wrapper tbody tr:hover {
    background-color: rgba(121, 114, 192, 0.2);
  }
  .visibility-item-hidden {
    opacity: 0.5;
  }
  .delete-button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;
    padding: 5px;
    background-color: transparent;
    transition: 0.2s linear;
    border-radius: 3px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
  .v-application .update-plan-link {
    display: inline-block;
    color: #fec111;
    text-decoration: underline;
    font-style: italic;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
      text-decoration: none;
    }
  }
  .visibility-item-forAll {
    cursor: default !important;
  }
</style>
